export enum EPropertyType {
  flat = 'flat',
  singleFamily = 'single-family',
  twinHouse = 'twin-house',
  rowHouse = 'row-house',
  /** Labelled "MFH - Mehrfamilienhaus" in the project creator. */
  townhouse = 'townhouse',
  /** Used by the project configurator v2 only. */
  villa = 'villa',
  commercial = 'commercial',
  other = 'other',
}
